import {Component, computed, ElementRef, ViewChild} from '@angular/core';
import {AppMenu} from './app.menu';
import {LayoutService} from '@/layout/service/layout.service';
import {RouterModule} from '@angular/router';
import {AppTopbar} from "@/layout/components/app.topbar";
import {CommonModule} from "@angular/common";
import { environment } from 'src/environments/environment';

@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [CommonModule,AppMenu, RouterModule, AppTopbar],
    template: `<div class="layout-sidebar" [ngClass]="menuColor" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
        <div class="sidebar-header">
            <a class="logo" [routerLink]="['/']">
                <img [src]="logoImage()" alt="jornadaDigitalLogo" [ngClass]="{'w-[80%]': isSidebarExpanded(), 'w-[40px]': !isSidebarExpanded()}" />
            </a>
            <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
        </div>
        <div class="!text-red-900 text-xl font-bold">{{textType}}</div>

        <div #menuContainer class="layout-menu-container">
            <div app-menu></div>
        </div>
        <div app-topbar *ngIf="isHorizontal()"></div>
    </div>`,
})

//<img class="logo-image" [src]="menuTheme() === 'light' ? '/layout/images/logo-dark.svg' : '/layout/images/logo-white.svg'" alt="diamond-layout" />
                //<span class="app-name title-h7">DIAMOND3</span>

export class AppSidebar {

    private environmentUrl: string = '';
    public menuColor: string = '';
    public textType: string = '';


    timeout: any = null;

    isHorizontal = computed(() => this.layoutService.isHorizontal());

    menuTheme = computed(() => this.layoutService.layoutConfig().menuTheme);

    // Detecta se a sidebar está expandida (ativa ou ancorada)
    isSidebarExpanded = computed(() => {
        const state = this.layoutService.layoutState();
        return state.sidebarActive || state.anchored;
    });

    // Define qual imagem usar baseado no estado da sidebar
    logoImage = computed(() => {
        const isExpanded = this.isSidebarExpanded();

        // Quando colapsada, usa uma imagem menor/ícone
        if (!isExpanded) {
            return 'assets/layout/images/favicon.png'; // Logo pequeno/ícone
        }

        // Quando expandida, usa a imagem completa
        return 'assets/layout/images/jornada-digital-1.png'; // Logo completo
    });

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) {
        this.environmentUrl = environment.ApiCore;
        if (this.environmentUrl.startsWith('https://localhost')) {
            this.menuColor = '!bg-gray-100';
            this.textType= 'LOCAL';
        }
        if (this.environmentUrl.startsWith('https://dev.')) {
            this.menuColor = '!bg-green-100';
            this.textType = 'DEV';
        }
        if (this.environmentUrl.startsWith('https://hml.')) {
            this.menuColor = '!bg-red-100';
            this.textType = 'HML';
        }
        console.log(this.menuColor);
    }

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored
        }));
    }
}
